import { __values } from "tslib";
import { useMemo } from 'react';
var AVATAR_COLORS = [
    'avatar.tomato',
    'avatar.blueberry',
    'avatar.oasis',
    'avatar.gold',
    'avatar.sage',
    'avatar.ash',
    'avatar.persimmon',
    'avatar.pear',
    'avatar.brass',
    'avatar.lake',
];
export function getAvatarColorTokenFromId(id) {
    var e_1, _a;
    var hash = 0;
    var total = AVATAR_COLORS.length;
    try {
        for (var _b = __values("" + (id !== null && id !== void 0 ? id : '')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var i = _c.value;
            hash = hash + String(i).charCodeAt(0);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (hash < 0)
        hash = -hash;
    return AVATAR_COLORS[hash % total];
}
/**
 * get color with `id` from buildIn avatar color map
 */
export var useAvatarColorToken = function (id) {
    var result = useMemo(function () { return getAvatarColorTokenFromId(id); }, [id]);
    return result;
};
